<template>
  <div class="block">
    <div class="block-title">推广位管理</div>
    <el-form :model="searchForm" class="search-form">
      <el-form-item label="推广位名称">
        <el-select v-model="searchForm.code" placeholder="请选择推广位名称">
          <el-option v-for="item in promoteList" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="应用名">
        <el-select v-model="searchForm.referMiniKey" placeholder="请选择应用名">
          <el-option v-for="item in referMiniList" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar">
      <!-- 新增推广位 -->
      <promote-create :referMiniData="referMiniData" @refresh="onRefresh" />
    </div>
    <!-- 表格-->
    <el-table ref="table" header-row-class-name="header" border highlight-current-row row-key="code"
      :data="table.dataSource" v-loading="table.loading">
      <el-table-column label="推广位ID" min-width="120" prop="code">
      </el-table-column>
      <el-table-column label="推广位名称" min-width="120" prop="name">
      </el-table-column>
      <el-table-column label="应用名" min-width="120" prop="referMiniName">
      </el-table-column>
      <el-table-column label="佣金收入（元）" min-width="120" prop="commission">
      </el-table-column>
      <el-table-column label="投入成本（元）" min-width="120" prop="costPriceYuan">
      </el-table-column>
      <el-table-column label="回本率" min-width="80" prop="rate">
        <template slot-scope="{ row }">
          <div>{{ row.rate }}%</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="110" prop="remark">
        <template slot-scope="{ row }">
          <el-tooltip class="item" effect="dark" :content="row.remark" placement="top-start">
            <div class="table-remark">{{ row.remark }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="165" prop="createTime">
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="160">
        <template slot-scope="{ row }">
          <div class="table-opt">
            <!-- 查看链接 -->
            <link-detail :row="row"></link-detail>
            <!-- 编辑推广位 -->
            <promote-create isEdit :row="row" :referMiniData="referMiniData" @refresh="onRefresh" />
            <span class="table-del" @click="onDel(row)">删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini()
import promoteCreate from "./PromoteCreate"
import linkDetail from "./LinkDetail"
const searchParams = {
  referMiniKey: '',// 应用名
  code: "", // 推广位名称
};
export default {
  components: {
    linkDetail,// 链接详情
    promoteCreate // 新增、编辑推广位
  },
  data() {
    return {
      referMiniData: [],//应用名
      referMiniList: [ // 应用名列表 含全部
      ],
      promoteList: [ // 推广位列表
      ],
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        // selectRowsIds: [], // 选中数据
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
    };
  },
  mounted() {
    this.getPromoteList();
    this.getMiniAppList()
    this.freshTable();
  },
  methods: {
    // 删除推广位
    onDel(row) {
      console.log(row, 'row')
      this.$confirm('是否删除该推广位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await MiniModel.delPromote({ idStr: row.id.toString() })
        if (data.data.code === 200) {
          this.$message({
            type: 'success',
            message: data.data.message
          });
          this.onRefresh()
        } else {
          this.$message({
            type: 'error',
            message: data.data.message
          });
        }

      })
    },
    // 获取推广位名称列表
    async getPromoteList() {
      const data = await MiniModel.getPromoteList({})

      if (data.data.code === 200) {

        this.promoteList = data.data.data.map((item) => (
          {
            value: item.code,
            label: item.name
          }
        ))
        this.promoteList.unshift({
          value: '',
          label: '全部'
        })
      }

    },
    // 获取应用名列表
    async getMiniAppList() {
      const data = await MiniModel.getMiniAppList({})
      if (data.data.code === 200) {

        this.referMiniList = data.data.data.map((item) => (
          {
            value: item.appKey,
            label: item.appName
          }
        ))
        this.referMiniData = JSON.parse(JSON.stringify(this.referMiniList))
        this.referMiniList.unshift({
          value: '',
          label: '全部'
        })
      }
    },
    // 刷新
    onRefresh() {
      this.freshTable();
      this.getPromoteList()
    },

    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 表单重置`
    onFormReset() {
      this.searchForm = Object.assign({}, searchParams);
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      const data = await MiniModel.getPromotePage({
        ...this.pagination,
        ...this.searchForm,
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.table-remark {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/promotionManage/index.vue